<section class="content" id="contentPrint" #contentPrint>
    
    <header id="header">
      <header-relatorio />
    </header>

    <main style="padding: 0rem 0rem 1rem 0rem;" ID="content">

      <section id="section1">

        <h5>
          Informações Beneficiário
         </h5>

        <div class="content__resultado__grid__main">

          <div class="">
              <div class="col-12 px-2 content__sub__titulo">Dados do pagamento</div>
          </div>

          <div class="row content__sub__details">
              <div class="col-6 px-2">
                  <span class="subtitle__row">Referência:</span>
                  <span class="table__card__valor">{{paymentAnalyze.reference}}</span>
              </div>
              <div class="col-6 px-2">
                  <span class="subtitle__row">Data de Pagamento:</span>
                  <span class="table__card__valor">{{paymentAnalyze.paymentDate | date: 'dd/MM/yyyy'}}</span>
              </div>
          </div>

          <div class="">
            <div class="col-12 px-2 content__sub__titulo">Dados do participante</div>
          </div>

          <div class="row content__sub__details">
              <div class="col-5 px-2">
                  <span class="subtitle__row">Nome:</span>
                  <span class="">{{paymentAnalyze.name}}</span>
              </div>
              <div class="col-4 px-2">
                  <span class="subtitle__row">Registro/Matrícula:</span>
                  <span class="">{{paymentAnalyze.register}}</span>
              </div>
              <div class="col-3 px-2">
                <span class="subtitle__row">CPF:</span>
                <span class="">{{paymentAnalyze.cpf | cpfCnpj}}</span>
            </div>
          </div>
          <div class="row content__sub__details">
            <div class="col-6 px-2">
                <span class="subtitle__row">Beneficiário:</span>
                <span class="">{{paymentAnalyze.beneficiary}}</span>
            </div>
            <div class="col-6 px-2">
                <span class="subtitle__row">Dependentes IR:</span>
                <span class="">{{paymentAnalyze.dependentIR}}</span>
            </div>
        </div>

        <div class="">
          <div class="col-12 px-2 content__sub__titulo">Dados do participante</div>
        </div>

        <div class="row content__sub__details">
          <div class="col-5 px-2">
              <span class="subtitle__row">Banco:</span>
              <span class="">{{paymentAnalyze.bank || ' - '}}</span>
          </div>
          <div class="col-4 px-2">
              <span class="subtitle__row">Agência:</span>
              <span class="">{{paymentAnalyze.agency || ' - '}}</span>
          </div>
          <div class="col-3 px-2">
            <span class="subtitle__row">Conta:</span>
            <span class="">{{paymentAnalyze.account || ' - '}}</span>
          </div>
        </div>
          
        </div>

        <h5>
          Pagamentos
         </h5>

        <div>

          <div class="mt-2">
            <div class="col-12 px-2 content__sub__titulo">Vantagens</div>
          </div>

          <section class="content__resultado__grid__main content__grid__table">
            <section class="content__header__table">
              <div class="col-1 text-center">Verba</div>
              <div class="col-8">Descrição</div>
              <div class="col-3 text-center">Valor</div>
            </section>
            <section class="content__main__table">
              <div class="table__card" *ngFor="let payment of paymentAnalyze.paymentItems">
                <div class="col-1 text-center">{{payment.code}}</div>
                <div class="col-8">{{payment.description}}</div>
                <div class="col-3 text-center">{{payment.value | currency:'BRL'}}</div>
              </div>
            </section>
            <section class="content__footer__table">
              <div class="table__card" style="background: #f2f2f2;">                
                <div class="col-9 px-0 text-right">
                  <b style="font-weight: 500;">Valor Total de Vantagens:</b>
                </div>
                <div class="col-3 px-1 text-center">
                  <b>{{paymentAnalyze.paymentTotal | currency:'BRL'}}</b>
                </div>
              </div>
            </section>
          </section>

        </div>

        <div>

          <div class="mt-2">
            <div class="col-12 px-2 content__sub__titulo">Descontos</div>
          </div>

          <section class="content__resultado__grid__main content__grid__table">
            <section class="content__header__table">
              <div class="col-1 text-center">Verba</div>
              <div class="col-8">Descrição</div>
              <div class="col-3 text-center">Valor</div>
            </section>
            <section class="content__main__table">
              <div class="table__card" *ngFor="let descontPayment of paymentAnalyze.descontPaymentItems">
                <div class="col-1 text-center">{{descontPayment.code}}</div>
                <div class="col-8">{{descontPayment.description}}</div>
                <div class="col-3 text-center">{{descontPayment.value | currency:'BRL'}}</div>
              </div>
            </section>
            <section class="content__footer__table">
              <div class="table__card" style="background: #f2f2f2;">                
                <div class="col-9 px-0 text-right">
                  <b style="font-weight: 500;">Valor Total de Descontos:</b>
                </div>
                <div class="col-3 px-1 text-center">
                  <b>{{paymentAnalyze.descontPaymentTotal | currency:'BRL'}}</b>
                </div>
              </div>
            </section>
          </section>

        </div>

        <section style="padding: 0.75rem 0.5rem !important;">
          <div class="table__card" style="background: #fcefd6; margin-top: 0.25rem;">                
            <div class="col-9 px-0 text-right">
              <b style="font-weight: 500;">Valor Líquido:</b>
            </div>
            <div class="col-3 px-1 text-center">
              <b>{{paymentAnalyze.paymentMinusDescontTotal | currency:'BRL'}}</b>
            </div>
          </div>
        </section>

      </section>

      <section id="section2">
        <h5>
         Demonstrativos de Despesas do Plano de Saúde
        </h5>

        <div class="mt-2">
          <div class="col-12 px-2 content__sub__titulo">Mensalidades</div>
        </div>

        <ng-template #naoPossuiMensalidades>
          <p class="ng-template">Neste mês de referência não houveram mensalidades!</p>
        </ng-template>

        <section class="content__resultado__grid__main content__grid__table" *ngIf="paymentAnalyze.monthlyHealthResumeItems && paymentAnalyze.monthlyHealthResumeItems.length > 0 else naoPossuiMensalidades">
          <section class="content__header__table">
            <div class="col-4 text-center">Beneficiário</div>
            <div class="col-2">Faixa Etária</div>
            <div class="col-3 text-center">Valor Total</div>
            <div class="col-3 text-center">Valor do Beneficiário</div>
          </section>
          <section class="content__main__table">
            <div class="table__card" *ngFor="let monthlyHealthResume of paymentAnalyze.monthlyHealthResumeItems">
              <div class="col-4 text-center">{{monthlyHealthResume.beneficiary}}</div>
              <div class="col-2">{{monthlyHealthResume.groupAge}}</div>
              <div class="col-3 text-center">{{monthlyHealthResume.totalValue | currency:'BRL'}}</div>
              <div class="col-3 text-center">{{monthlyHealthResume.beneficiaryValue | currency:'BRL'}}</div>
            </div>
          </section>
        </section>

      </section>
      
      <section id="section3">

        <h5>
          Saldos Devedores
         </h5>
 
         <div class="mt-2">
           <div class="col-12 px-2 content__sub__titulo">Saldos devedores de saúde</div>
         </div>

         <ng-template #naoPossuiSaude>
            <p class="ng-template">Neste mês de referência não há saldo devedor de saúde!</p>
         </ng-template>

          <section class="content__resultado__grid__main content__grid__table">
            <section class="content__header__table">
              <div class="col-6">Data do Débito</div>
              <div class="col-6 text-center">Valor</div>              
            </section>
            <section class="content__main__table">
              <div class="table__card" *ngFor="let healthDebit of paymentAnalyze.healthDebitItems">
                <div class="col-6">{{healthDebit.paymentDate | date: 'dd/MM/yyyy'}}</div>
                <div class="col-6 text-center">{{healthDebit.value | currency:'BRL'}}</div>                
              </div>
            </section>
          </section>


        <div class="mt-2">
          <div class="col-12 px-2 content__sub__titulo">Saldos devedores de Empréstimos</div>
        </div>

        <ng-template #naoPossuiEmprestimos>
          <p class="ng-template">Neste mês de referência não há saldo devedor de empréstimos!</p>
       </ng-template>

        <section class="content__resultado__grid__main content__grid__table" *ngIf="paymentAnalyze.loan && paymentAnalyze.loan.length > 0 else naoPossuiEmprestimos">
          <section class="content__header__table">
            <div class="col-4">Descrição</div>
            <div class="col-4 text-center">Parcelas Restantes</div>
            <div class="col-4 text-center">Valor</div>
          </section>
          <section class="content__main__table">
            <div class="table__card" *ngIf="paymentAnalyze.loan">
              <div class="col-4">{{paymentAnalyze.loan.description}}</div>
              <div class="col-4 text-center">{{paymentAnalyze.loan.leftPays}}</div>              
              <div class="col-4 text-center">{{paymentAnalyze.loan.leftValueToPay | currency:'BRL'}}</div>              
            </div>
          </section>
        </section>

      </section>

    </main>

    <footer id="footer">
        <footer-relatorio />    
    </footer>
    
</section>